import { cn } from "@/lib/utils";

type Props = {
	as?: React.ElementType;
	className?: string;
	containerClassName?: string;
	children?: React.ReactNode;
};

export const Container = ({
	as,
	className,
	containerClassName,
	children,
}: Props) => {
	const Component = as ?? "div";

	return (
		// @ts-ignore: // TODO: fix this
		<Component className={cn("px-6 lg:px-8", containerClassName)}>
			<div className={cn("mx-auto max-w-7xl", className)}>{children}</div>
		</Component>
	);
};
